import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { getProductsByCategory } from "../services/productService";
import { Plus } from "lucide-react";
import "../styles/Categories.css";
import { BASE_URL, IMAGE_BASE_URL } from "../api/api";


function CategoryPage() {
  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [sortType, setSortType] = useState("default");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const data = await getProductsByCategory(id);
        setProducts(data);
      } catch (error) {
        console.error("Error loading products:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [id]);

  const handleSortChange = (e) => setSortType(e.target.value);

  // Sort products
  const sortedProducts = [...products].sort((a, b) => {
    if (sortType === "price-low-high") return a.price - b.price;
    if (sortType === "price-high-low") return b.price - a.price;
    if (sortType === "alphabetical") return a.name.localeCompare(b.name);
    return 0;
  });

  if (loading) return <p className="text-center mt-5">Loading products...</p>;

  return (
    <div className="container my-5">
      {/* Updated route path with clickable Home */}
      <p className="mb-5 routepath_title">
        <Link
          to="/"
          className="text-decoration-none routepath-link"
          style={{
            color: '#6c757d',
            transition: 'color 0.2s ease'
          }}
          onMouseEnter={(e) => e.target.style.color = '#FD7E14'}
          onMouseLeave={(e) => e.target.style.color = '#6c757d'}
        >
          Home
        </Link>
        <span className="mx-1">/</span>
        Category
      </p>

      <div className="d-flex justify-content-between align-items-center mb-3">
        <p className="mb-0 section-title">All Products</p>
      </div>

      {/* Sorting */}
      <div className="mb-3 d-flex justify-content-end">
        <select
          value={sortType}
          onChange={handleSortChange}
          className="form-select w-auto"
        >
          <option value="default">Sort By</option>
          <option value="price-low-high">Price: Low to High</option>
          <option value="price-high-low">Price: High to Low</option>
          <option value="alphabetical">Alphabetical</option>
        </select>
      </div>

      {/* Product Grid */}
      <div className="d-flex flex-wrap gap-3 justify-content-between justify-content-center-mobile">
        {sortedProducts.map((product) => {
          const primaryImage = product.images?.find((img) => img.is_primary);
          return (
            <div
              key={product.id}
              className="card border-0 product-card"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`/product/${product.id}`)}
            >
              <div className="position-relative">
                <img
                  src={
                    primaryImage
                      ? `${IMAGE_BASE_URL}storage/${primaryImage.image_path}`
                      : "https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM="
                  }
                  alt={product.name}
                  className="card-img-top"
                />

                <button
                  className="position-absolute d-flex justify-content-center align-items-center"
                  style={{
                    bottom: "10px",
                    right: "10px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    backgroundColor: "#FD7E14",
                    border: "none",
                    cursor: "pointer",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    console.log("Add to cart clicked for", product.name);
                  }}
                >
                  <Plus size={20} color="white" />
                </button>
              </div>
              <div className="card-body p-2">
                <h6 className="card-title mb-1">{product.name}</h6>
                <p className="Cardprice-title text-muted mb-0">
                  Rs.{product.price}.00
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CategoryPage;